export const storeModule = {
    localization: 'localization',
  };